var dateMix = {
    methods: {
        convertDate(date) {
            let ddd = new Date(date);
			return `${ ddd.getFullYear() }-${ (ddd.getMonth() + 1) < 10 ? '0' + (ddd.getMonth() + 1) : ddd.getMonth() }-${ ddd.getDate() < 10 ? '0' + ddd.getDate() : ddd.getDate() }`;
        }
    }
}

export default dateMix;
